var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 21.9999H18.6666V25.3333H15.3333V21.9999ZM15.3333 8.66659H18.6666V18.6666H15.3333V8.66659ZM16.9833 0.333252C7.78325 0.333252 0.333252 7.79992 0.333252 16.9999C0.333252 26.1999 7.78325 33.6666 16.9833 33.6666C26.1999 33.6666 33.6666 26.1999 33.6666 16.9999C33.6666 7.79992 26.1999 0.333252 16.9833 0.333252ZM16.9999 30.3333C9.63325 30.3333 3.66659 24.3666 3.66659 16.9999C3.66659 9.63325 9.63325 3.66659 16.9999 3.66659C24.3666 3.66659 30.3333 9.63325 30.3333 16.9999C30.3333 24.3666 24.3666 30.3333 16.9999 30.3333Z",
    fill: "#EF3940"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.eb70aac3.svg";
export { ForwardRef as ReactComponent };